import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme=>({
	root: {
		flexGrow: 1,
	},	
	appBar: {
		backgroundColor: 'white',
		color: 'black',
	}, 
	title: {
		flexGrow: 1,
	},	
	buttonUpdate:{
		color: 'black',
	},
	menuButton: {
		marginRight: theme.spacing(2),
	},
}))